import { Grid } from '@mui/material';
import cn from 'classnames';
import { FC } from 'react';

import { useActions } from '../../../../../hooks/useActions';
import { useUser } from '../../../../../hooks/useUser';

import styles from './NotAuthFields.module.sass';

const NotAuthFields: FC = () => {
  const { setAuthVisible } = useActions();
  const { visibleAuthDialog } = useUser();
  //Открыть окно авторизации
  const handleOpenAuthModal = () => {
    setAuthVisible(!visibleAuthDialog);
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.contactInformation}>
        <h1 className={styles.title}>Контактная информация</h1>
        <div className={styles.auth}>
          <span onClick={handleOpenAuthModal}>
            Войти или зарегистрироваться
          </span>
          , чтобы оформить заказ
        </div>
      </div>

      <div className={styles.bottomWrapper}>
        <div className={styles.contactInformation}>
          <h1 className={styles.title}>Способ получения</h1>
          <div className={cn(styles.auth, styles.bottomAuth)}>
            <span onClick={handleOpenAuthModal}>
              Войти или зарегистрироваться
            </span>
            , чтобы оформить заказ
          </div>
        </div>

        <div className={styles.contactInformation}>
          <h1 className={styles.title}>Способ оплаты</h1>
          <div className={cn(styles.auth, styles.bottomAuth)}>
            <span onClick={handleOpenAuthModal}>
              Войти или зарегистрироваться
            </span>
            , чтобы оформить заказ
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotAuthFields;
